import { OpinionsItemsInterface } from 'interfaces/opinions.interface';

export function offerOpinionSort(selectedSort: string): (prev: OpinionsItemsInterface, next: OpinionsItemsInterface) => number {
    if (selectedSort === '') {
        return (prev: OpinionsItemsInterface, next: OpinionsItemsInterface): number => next.timestamp - prev.timestamp;
    }

    if (selectedSort === 'likes') {
        return (prev: OpinionsItemsInterface, next: OpinionsItemsInterface): number => next.likes - prev.likes;
    }

    return (): number => 0;
}
